export enum CompanyType {
    HOME = "home",
    BUSINESS = "business",
    PUBLIC = "public",
}

export interface CompanyListModel {
    id: string;
    name: string;
    type: CompanyType;
    hasEipaConfiguration?: boolean;
    isSubscriptionActive?: boolean;
}

export interface CompanyDetailsModel extends CompanyListModel {
    invoiceData: {
        name: string | null;
        vatId: string | null;
        address: {
            address1: string | null;
            address2: string | null;
            city: string | null;
            postalCode: string | null;
        } | null;
    } | null;
    isSubscriptionActive: boolean;
    hasDefaultTariff: boolean;
    activatedAt: string;
    eipaUsername: string | null;
    eipaPasswordSet: boolean;
    currentPlan: string;
    nextMonthPlan: string;
}

export interface CompanyPlanModel {
    standard: {
        commissionRate: string;
        baseFeePerStation: string;
        stationNumberLimit: number | null;
    };
    custom?: {
        commissionRate: string;
        baseFeePerStation: string;
        simCardFeePerStation: string;
        helpdeskFeePerOneHundredStations: string;
        managementFeePerStation: string;
        hasCustomMobileApp: boolean;
        validToYear: number;
        validToMonth: number;
    };
    flatCommissionAmount: string;
}
